/**
 *
 * Custom function
 *
 */

(function($) {

	$(document).ready(function() {

		scrollAnimations(270, true);
		scrollAnimationsUp();
		mobiToggleLang();
/*
		$('#efp-children').change(function() {
			if ( $( window ).width() > 991 ) {
				//$('.js-equalHeight-form-group').equalHeights();
				var h = $('.form-section-4').height();
				//alert('h: '+h);
				if ($('#efp-children').val() > 2) h += 120;
				else if ($('#efp-children').val() > 0) h += 60;
				$('.form-section-1').height(h);
				$('.form-section-2').height(h);
				$('.form-section-3').height(h);
			}
		});
*/
	});

	function scrollAnimations(desktopScrollTop, desktopScrollBol) {

		var header = $('#js-header'),
				menu = $('#js-fixed-menu'),
				desktopFixedMenu = $('#js-desktopFixedMenu'),
				windowWidth = $(window).width();

		if ($('body').is('.is-mobile')) {
				var headerH = $('#js-header').outerHeight(), // Height compreso di margini e bordi
						menuH = $('#js-fixed-menu').innerHeight(), // Height senza margini e bordi
						scrollValue = headerH - menuH;

				header.css('height', headerH);

		}

		$(window).scroll(function() {
				scrolltop = $(window).scrollTop();

				if ($('body').is('.is-mobile')) {
					if ( scrolltop >= scrollValue) {
							menu.addClass("scroll");
					} else {
							menu.removeClass("scroll");
					}
				} else if ( desktopScrollBol ) {
					if (scrolltop >= desktopScrollTop) {
						header.addClass("scroll");
					} else {
						header.removeClass("scroll");
					}
				}

		});

	}

	/*
	 *  Funzione per il toggle del menu delle lingue nel mobile
	*/
	function mobiToggleLang(){
			if($("body").is('.mobile')){
					$(".current-lang").click(function(evt){
							$(".lang-wrapper").toggleClass("show");
					});
			} else {
					$('.current-lang').click(function(evt) {
							evt.preventDefault();
							$('nav.language').toggle();
					});
			}
	}

	function scrollAnimationsUp(){

		var elements_up = $('.return-up');

		//if( !$("body").is('.is-mobile') ){
			$(window).scroll(function(){
				var scrolltop = $(window).scrollTop();

				if( scrolltop >= 800 ) elements_up.addClass("active");
				else elements_up.removeClass("active");
			});
		//}
	}

  $(window).load(function() {

		if ( $( window ).width() > 991 ) {

			//$('.js-equalHeights-form-group').equalHeights();
			$('.js-equalHeights-buoni-motivi-h3').equalHeights();
			$('.js-equalHeights-offerte-h2').equalHeights();
			$('.js-equalHeights-offerte-prezzo').equalHeights();
			$('.js-equalHeights-offerte-foto-prezzo').equalHeights();

		} else {
		}
		$('.js-equalHeights-offerte-testo').equalHeights();
		$('.js-equalHeights-buoni-motivi-h2').equalHeights();

	});

	$(window).resize(function() {

		if ( $( window ).width() > 991 ) {

			//$('.js-equalHeights-form-group').equalHeights();
			$('.js-equalHeights-buoni-motivi-h3').equalHeights();
			$('.js-equalHeights-offerte-h2').equalHeights();
			$('.js-equalHeights-offerte-prezzo').equalHeights();
			$('.js-equalHeights-offerte-foto-prezzo').equalHeights();

		} else {
		}
		$('.js-equalHeights-buoni-motivi-h2').equalHeights();
		$('.js-equalHeights-offerte-testo').equalHeights();

	});

})(jQuery);
